import React, { useEffect, useState } from 'react';
import { FilterSelect } from "dsilo-ui-components";

import { Tooltip, Typography } from '@material-ui/core';

import AddIcon from '@material-ui/icons/Add';
import Button from '@material-ui/core/Button';
import SubDataModelTable from './SubDataModelTableTask';
import SubDataModelModal from './SubDataModelModal.js';
import { toast } from 'react-toastify';

import useStyles from './styles.js';
import { makeStyles } from '@material-ui/core/styles';

const useLocalStyles = makeStyles((theme) => ({
  // Row that holds "Tasks :" label
  titleRow: {
    display: 'flex',
    justifyContent: 'start',
    alignItems: 'center',
  },
  tasksLabel: {
    fontWeight: 400,
    fontSize: 12,
    color: 'rgba(117, 117, 117, 1)',
    fontStyle: 'medium',
    flexGrow: 1,
    [theme.breakpoints.down('md')]: { fontSize: 11.5 },
    [theme.breakpoints.down('sm')]: { fontSize: 11 },
  },

  // Table wrapper row
  tableContainer: {
    display: 'flex',
    justifyContent: 'start',
    alignItems: 'center',
    marginTop: 16,
    marginBottom: 10,
    [theme.breakpoints.down('md')]: {
      marginTop: 14,
      marginBottom: 8,
    },
    [theme.breakpoints.down('sm')]: {
      marginTop: 12,
      marginBottom: 8,
    },
  },

  // Add button row
  addRow: {
    display: 'flex',
    justifyContent: 'start',
    alignItems: 'center',
  },
  addButton: {
    backgroundColor: 'rgba(255, 255, 255, 1)',
    color: 'rgba(19, 126, 249, 1)',
    // use MUI Small but still allow responsive tweaks
    [theme.breakpoints.down('sm')]: {
      padding: '2px 6px',
    },
  },
  addButtonInner: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    gap: 5,
  },
  addIcon: {
    color: 'rgba(19, 126, 249, 1)',
    height: 19,
    width: 19,
    [theme.breakpoints.down('sm')]: {
      height: 18,
      width: 18,
    },
  },
  addText: {
    fontWeight: 400,
    fontSize: 14,
    color: 'rgba(19, 126, 249, 1)',
    fontStyle: 'normal',
    [theme.breakpoints.down('md')]: { fontSize: 13.5 },
    [theme.breakpoints.down('sm')]: { fontSize: 13 },
  },
}));

const SubDataModelTaskViewer = (props) => {
  const classes = useStyles();        // from ./styles.js (existing)
  const local = useLocalStyles();     // new local styles for moved inline CSS

  const { orgId, appId, members, currentOpportunityId, formData, selectedStep, block, loader } = props
  const { document } = props.formData
  const { chartUniqueId } = props.data
  const [allTasksCompleted, setAllTasksCompleted] = useState(false);
  const [blockState, setBlockState] = useState([])
  const [tableHeaders, setTableHeaders] = useState([])
  const [formHeaders, setFormHeaders] = useState([])
  const [currentDataModel, setCurrentDataModel] = useState({})

  const [modalInfo, setModalInfo] = useState({
    enable: false
  })

  const [anchorElDrop, setAnchorElDrop] = useState(null);

  const handleClick = (event) => {
    setAnchorElDrop(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorElDrop(null);
  };

  useEffect(() => {
    if (block.enable) {
      fetchDataModel()
      getNeededDataForBlock()
      getWorkflow(block.workFlowId)
      getFirstStepMembers()
    }
  }, [block])

  useEffect(() => {
    if (formData?.dataModel[block?.dataModel]) {
      const dataElements = formData.dataModel[block.dataModel].dataElements || []
      let tHeaders = []
      let fHeaders = []
      if (block.list?.dataElements?.length) {
        tHeaders = getHeaders(dataElements, block.list.dataElements)
      }
      if (block.form?.dataElements?.length) {
        fHeaders = getHeaders(dataElements, block.form.dataElements)
      }
      setTableHeaders(tHeaders)
      setFormHeaders(fHeaders)
      setCurrentDataModel(formData.dataModel[block.dataModel])
    }
  }, [formData?.dataModel[block?.dataModel]])


  useEffect(() => {
    if (props.formData?.document[chartUniqueId + '_Tasks_Execute_Workflow']) {
      const executeWorkFlow = props.formData?.document[chartUniqueId + '_Tasks_Execute_Workflow']
      const message = executeWorkFlow?.message || "Workflow executed successfully"
      showConfirmationDialogORToast('success', message)
    } else {
      console.log("Error in Update Identify Step");
    }
  }, [props.formData?.document[chartUniqueId + '_Tasks_Execute_Workflow']])

  useEffect(() => {
    if (document?.[chartUniqueId + '_Tasks_Execute_Workflow_Reject']) {
      const rejectWorkFlow = document[chartUniqueId + '_Tasks_Execute_Workflow_Reject']
      const message = rejectWorkFlow?.message || "Workflow executed successfully"
      showConfirmationDialogORToast('rejected', message)
    }
  }, [document?.[chartUniqueId + '_Tasks_Execute_Workflow_Reject']])

  useEffect(() => {
    if (document?.[`${chartUniqueId}_${block.name}_All_Task_Data`]) {
      const data = JSON.parse(JSON.stringify(document[`${chartUniqueId}_${block.name}_All_Task_Data`]));

      let mainstepresponder;

      let currentMemberLoggedIn = props?.members?.name;
      let currentMemberRoles = props?.members?.roles;

      if (document[`${chartUniqueId}_getsingleobligation`]) {
        const parentobligationdata = JSON.parse(JSON.stringify(document[`${chartUniqueId}_getsingleobligation`]));
        mainstepresponder = parentobligationdata?.workflow?.currentRespondent?.name;

      }

      const updatedData = data.map(d => {
        const assignedTo = d?.workflow?.currentRespondent?.name || null;
        const workflowExists = !!d?.workflow;

        const CurentTaskassigningRoles = d?.workflow?.currentRespondent?.name;
        const CurentTaskassigningName = d?.workflow?.respondent?.role || [];

        const showhide =
          assignedTo === currentMemberLoggedIn ||
          (currentMemberLoggedIn === mainstepresponder && assignedTo === mainstepresponder) ||
          (!workflowExists && currentMemberLoggedIn === mainstepresponder);

        const newRow = {
          ...d,
          assignedTo,
          showhide,
          tableActions: {}
        };

        newRow.tableActions.view = true;

        // === Case 2 ===
        if (CurentTaskassigningRoles === currentMemberLoggedIn) {
          if (d?.status?.toLowerCase() === 'complete') {
            newRow.tableActions.edit = false
          }
          else {
            newRow.tableActions.edit = true;
          }

        }

        // === Case 3 ===
        const hasMatchingRole = currentMemberRoles?.some(memberRole =>
          CurentTaskassigningName?.some(assigningRole => assigningRole?._id === memberRole.id)
        );
        if (hasMatchingRole && CurentTaskassigningRoles !== currentMemberLoggedIn) {
          if (d?.status?.toLowerCase() === 'complete') {
            newRow.tableActions.assignMe = false;
          }
          else {
            newRow.tableActions.assignMe = true;
          }
        }

        // === Case 4 ===
        if (currentMemberLoggedIn === mainstepresponder || currentMemberLoggedIn === CurentTaskassigningRoles) {
          if (d?.status?.toLowerCase() === 'complete') {
            newRow.tableActions.forwardTo = false;
          }
          else {
            newRow.tableActions.forwardTo = true;
          }
        }

        // === Case 5 ===
        if (currentMemberLoggedIn === mainstepresponder) {
          if (d?.status?.toLowerCase() === 'complete') {
            newRow.tableActions.delete = false;
          }
          else {
            newRow.tableActions.delete = true;
          }
        }

        return newRow;
      });


      const allTasksCompleted = updatedData.length === 0 || updatedData.every(task => task.status?.toLowerCase() === 'complete');
      setAllTasksCompleted(allTasksCompleted);
      props.showHideWorkFlow(allTasksCompleted)
      setBlockState(updatedData);
    }
  }, [document?.[`${chartUniqueId}_${block.name}_All_Task_Data`]])

  useEffect(() => {
    if (document?.[`${chartUniqueId}_Task_delete`]) {
      setModalInfo({
        enable: false,
      })
      toast.success(document?.[`${chartUniqueId}_Task_delete`]?.message)
      clearCurrentChartReduxStore()
      getNeededDataForBlock()
    }
  }, [document?.[`${chartUniqueId}_Task_delete`]])


  useEffect(() => {
    if (document?.[`${chartUniqueId}_Task_Assigned_To_Me`]) {
      toast.success(document?.[`${chartUniqueId}_Task_Assigned_To_Me`]?.message)
      clearCurrentChartReduxStore()
      getNeededDataForBlock()
    }
  }, [document?.[`${chartUniqueId}_Task_Assigned_To_Me`]])

  const getHeaders = (dataElements, selectedElements) => {
    let fdes = []
    if (selectedElements?.length) {
      fdes = JSON.parse(JSON.stringify(selectedElements))
    }
    if (dataElements?.length) {
      fdes = fdes.map(fde => {
        let sde = dataElements.find(de => de.name === fde.value)
        if (sde?.name) {
          return {
            ...sde,
            ...fde
          }
        } else {
          return fde
        }
      })
    }
    return fdes
  }

  const clearCurrentChartReduxStore = () => {
    let subKeys = [
      props.data.chartUniqueId + '_Tasks_Execute_Workflow',
      props.data.chartUniqueId + '_Next_Steps_Respondent_Tasks',
      props.data.chartUniqueId + '_Next_Step_Tasks',
      props.data.chartUniqueId + '_Tasks_Execute_Workflow_Reject',
      props.data.chartUniqueId + '_Task_Assigned_To_Me',
      props.data.chartUniqueId + '_Task_delete',
      props.data.chartUniqueId + '_All_Task_Data',

    ]
    // for clearing success/Reject message
    props.clearReduxDataOfCurrentComponent({
      key: "document",
      subKey: subKeys
    })
  }

  const showConfirmationDialogORToast = (type, message) => {
    if (type === 'success') {
      setModalInfo({
        enable: true,
        title: 'success',
        type,
        message
      })
    }
    if (type === 'rejected') {
      setModalInfo({
        enable: true,
        title: 'rejected',
        type,
        message
      })
    }

  }

  const getWorkflow = (workflowId) => {
    let payload = {
      id: workflowId,
      dataUniqueId: `${chartUniqueId}_Tasks_Workflow`,
      appId: props.match.params.appid,
    }
    props.getWorkflowById(payload)
  }

  const getFirstStepMembers = () => {
    let payload = {
      dataUniqueId: `${chartUniqueId}_Task_First_Step_Members`,
      payload: {
        "workFlowId": block.workFlowId
      },
      appId: props.match.params.appid,
    }
    props.getFirstStepMembers(payload)
  }


  const getNeededDataForBlock = () => {
    let payload = {
      appId: appId,
      orgId: orgId,
      dataModelId: block.mainDataModel,
      subDataModelId: block.dataModel,
      obligationId: currentOpportunityId,
      dataUniqueId: `${chartUniqueId}_${block.name}_All_Task_Data`
    }
    props.getAllTaskofobligation(payload)
  }

  const fetchDataModel = () => {
    let payload = {
      appid: appId,
      orgId: orgId
    }
    if (block?.dataModel) {
      if (!formData?.dataModel?.[block.dataModel] && !formData[`${block.dataModel}_loading`]) {
        payload['dataModelId'] = block.dataModel
        payload['dataUniqueId'] = block.dataModel
        props.getDataModelById(payload)
      }
    }
  }
  const onTableActionClick = (type, data, event) => {
    if (type === 'view') {
      setModalInfo({
        enable: true,
        title: 'Task',
        data,
        type
      })
    }
    if (type === 'edit') {
      setModalInfo({
        enable: true,
        title: 'Task',
        data,
        type
      })
    }

    if (type === 'assignToMe') {
      changeAssignee(
        {
          selfAssign: false,
          documentId: data._id,
          member: {
            id: props.members._id,
            name: props.members.name
          }
        }
      )
    }

    if (type === 'deleteTask') {
      setModalInfo({
        enable: true,
        title: 'Delete Task',
        data,
        type
      })
    }

    if (type === 'forwardTo') {
      setModalInfo({
        enable: true,
        title: 'Forward To',
        data,
        type
      })
    }
  }

  const onDeleteTask = (id) => {
    let payload = {
      appId: appId,
      orgId: orgId,
      dataModelId: block.dataModel,
      obligationId: id,
      data: {},
      dataUniqueId: `${chartUniqueId}_Task_delete`
    }
    props.deleteTaskofobligation(payload)
  }

  const changeAssignee = (payload) => {
    let finalpayload = {
      ...payload,
      appid: props.match.params.appid,
      dataModelId: block.dataModel,
      dataUniqueId: props.data?.chartUniqueId + '_Task_Assigned_To_Me',
    }

    props.changeAssigneeRequest(finalpayload)
  }

  const onAddTask = (type) => {
    if (type === 'create') {
      setModalInfo({
        enable: true,
        title: 'Create Task',
        type
      })
    }
  }

  const onCloseModel = () => {
    clearCurrentChartReduxStore()
    setModalInfo({
      enable: false,
    })
  }

  const onSaveHandler = (data) => {
    getNeededDataForBlock()
  }

  const onSucessClick = () => {
    setModalInfo({
      enable: false,
    })
    clearCurrentChartReduxStore()
    getNeededDataForBlock()
  }

  const onRejectedModel = () => {
    setModalInfo({
      enable: false,
    })
    clearCurrentChartReduxStore()
    getNeededDataForBlock()
  }



  return (
    <div>
      {
        (props.formData?.[`${chartUniqueId}_${block.name}_All_Task_Data_loading`]) ? props.loader :
          <div>
            <div className={local.titleRow}>
              <Typography component='span' className={local.tasksLabel}>
                Tasks :
              </Typography>
            </div>

            <div className={local.tableContainer}>
              <SubDataModelTable
                {...props}
                isWorkflowEnable={block.isWorkflowEnable ? true : false}
                onTableActionClick={onTableActionClick}
                handleClick={handleClick}
                handleClose={handleClose}
                anchorElDrop={anchorElDrop}

                enableActions={block.actions?.enable}
                tableActions={block.actions}
                tableHeaders={tableHeaders}
                tableRows={blockState}
                stripedTable={block.list?.stripedTable}
                tableStyle={block.list?.tableStyle || {}}
                stickyHeader={block.list?.stickyHeader}
                headerStyle={block.list?.headerStyle || {}}

                formData={formData}
                loader={loader}
                chartUniqueId={chartUniqueId}
                selectedStep={selectedStep}
                block={block}
                shouldDisableFields={props.shouldDisableFields}
                isLoading={formData[`${chartUniqueId}_${selectedStep.name}_${block.name}_loading`]} />
            </div>

            {
              !props.shouldDisableFields && (
                <div className={local.addRow}>
                  <Button className={local.addButton} size='small'>
                    <div className={local.addButtonInner} onClick={() => { onAddTask('create') }}>
                      <AddIcon className={local.addIcon} />
                      <Typography component='span' className={local.addText}>
                        Add Task
                      </Typography>
                    </div>
                  </Button>
                </div>
              )
            }

            {
              modalInfo?.enable && <SubDataModelModal
                {...props}
                isWorkflowEnable={block.isWorkflowEnable ? true : false}
                classes={classes}
                modalInfo={modalInfo}
                formHeaders={formHeaders}
                onCloseModel={onCloseModel}
                chartUniqueId={props.data.chartUniqueId}
                onSaveHandler={onSaveHandler}
                onSucessClick={onSucessClick}
                onRejectedModel={onRejectedModel}
                onDeleteTask={onDeleteTask}
              />
            }
          </div>

      }
    </div>
  );
}

export default SubDataModelTaskViewer
